/*!
 * @license Ranj B.V.
 * Copyright (c) 2020 Ranj B.V. all rights reserved 
 */

 //Vendors
import 'soma.js';
import 'createjs';

//Styles
import './css/style.css';
import './css/fonts.css';

import App from './ranj/app/core/App';
import TextOffsetFixer from './ranj/app/ui/text/TextOffsetFixer';
import RTLTextPatch from './ranj/app/ui/text/RTLTextPatch';
import FontReplacementPatch from './ranj/app/ui/text/FontReplacementPatch';


window.ranj = { DEBUG: DEFINE.DEBUG }; // for backwards compatibility (e.g. ranj.DEBUG)

function init() {
    // Apply RTL text support patch to createjs.Text
    RTLTextPatch.apply({ autoChangeTextAlign: false });
    
    // Apply font replacement patch to createjs.Text for language-specific fonts
    FontReplacementPatch.apply();
    
    ranj.TextOffsetFixer = TextOffsetFixer;//place in global scope so skin files can access the module

    const app = new App();
    if (ranj.DEBUG) {
        //Expose app instance globally for debugging
        ranj.app = app;
    }
}

init();